import { all, takeLatest, takeEvery } from "redux-saga/effects";
import importer from "common/importer";
/* PUBLIC CONTENT */
const { PublicContentTypes } = importer("Stores/PublicContent/Actions", null);
const PublicContent = importer("Sagas/PublicContent");
/* APPOINTMENTS */
const { AppointmentsTypes } = importer("Stores/Appointments/Actions", null);
const Appointments = importer("Sagas/Appointments");
// /* CENTERS */
const { CentersTypes } = importer("Stores/Centers/Actions", null);
const Centers = importer("Sagas/Centers");
// /* DONORS */
const { DonorTypes } = importer("Stores/Donors/Actions", null);
const Donor = importer("Sagas/Donors");
// /*LOYALTYDETAILS */
const { LoyaltyDetailsTypes } = importer("Stores/Loyalty/Actions", null);
const LoyalDonor = importer("Sagas/Loyalty");
/* USERS */
const { UsersTypes } = importer("Stores/Users/Actions", null);
const Users = importer("Sagas/Users");
/* WIRECARD */
const { WirecardTypes } = importer("Stores/Wirecard/Actions", null);
const Wirecard = importer("Sagas/Wirecard");
/* CUSTOM AUTHENTICATION */
const { AuthCustomTypes } = importer("Stores/AuthCustom/Actions", null);
const AuthCustom = importer("Sagas/AuthCustom");

const { PaymentsTypes } = importer("Stores/Payments/Actions", null);
const Payments = importer("Sagas/Payments");

const { StartupTypes } = importer("Stores/Startup/Actions", null);
const Startup = importer("Sagas/Startup");

const { PreviewTypes } = importer("Stores/Preview/Actions", null);
const Preview = importer("Sagas/Global");

const { ChatbotTypes } = importer("Stores/Chatbot/Actions", null);
const Chatbot = importer("Sagas/Chatbot");

export default function* root() {
  yield all([
    /* PUBLIC CONTENT */
    //

    takeLatest(ChatbotTypes.GET_CHATBOT_RESPONSE, Chatbot.getChatbotResponse),
    // takeLatest(
    //   ChatbotTypes.GET_CHATBOT_INITIAL_STATE,
    //   Chatbot.getChatbotInitialState
    // ),
    takeLatest(
      ChatbotTypes.GET_CHATBOT_RESPONSE_SUCCESS,
      Chatbot.getChatbotResponseSuccess
    ),
    takeLatest(
      ChatbotTypes.GET_CHATBOT_RESPONSE_FAILURE,
      Chatbot.getChatbotResponseFailure
    ),

    takeLatest(
      PublicContentTypes.GET_LOYALTY_MILESTONES,
      PublicContent.getLoyaltyMilestones
    ),
    takeLatest(
      PublicContentTypes.GET_LOYALTY_MILESTONES_SUCCESS,
      PublicContent.getLoyaltyMilestonesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_LOYALTY_MILESTONES_FAILURE,
      PublicContent.getLoyaltyMilestonesFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_MESSAGES, PublicContent.getMessages),
    takeLatest(
      PublicContentTypes.GET_MESSAGES_SUCCESS,
      PublicContent.getMessagesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_MESSAGES_FAILURE,
      PublicContent.getMessagesFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_CENTERS, PublicContent.getCenters),
    takeLatest(
      PublicContentTypes.GET_CENTERS_SUCCESS,
      PublicContent.getCentersSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_CENTERS_FAILURE,
      PublicContent.getCentersFailure
    ),
    //
    takeLatest(
      PublicContentTypes.GET_CENTERS_FOR_MOBILE,
      PublicContent.getCentersForMobile
    ),
    takeLatest(
      PublicContentTypes.GET_CENTERS_FOR_MOBILE_SUCCESS,
      PublicContent.getCentersForMobileSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_CENTERS_FOR_MOBILE_FAILURE,
      PublicContent.getCentersForMobileFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_GENDERS, PublicContent.getGenders),
    takeLatest(
      PublicContentTypes.GET_GENDERS_SUCCESS,
      PublicContent.getGendersSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_GENDERS_FAILURE,
      PublicContent.getGendersFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_COUNTRIES, PublicContent.getCountries),
    takeLatest(
      PublicContentTypes.GET_COUNTRIES_SUCCESS,
      PublicContent.getCountriesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_COUNTRIES_FAILURE,
      PublicContent.getCountriesFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_ALL_STATES, PublicContent.getAllStates),
    takeLatest(
      PublicContentTypes.GET_ALL_STATES_SUCCESS,
      PublicContent.getAllStatesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_ALL_STATES_FAILURE,
      PublicContent.getAllStatesFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_LANGUAGES, PublicContent.getLanguages),
    takeLatest(
      PublicContentTypes.GET_LANGUAGES_SUCCESS,
      PublicContent.getLanguagesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_LANGUAGES_FAILURE,
      PublicContent.getLanguagesFailure
    ),
    //
    takeLatest(PublicContentTypes.GET_PHONE_TYPES, PublicContent.getPhoneTypes),
    takeLatest(
      PublicContentTypes.GET_PHONE_TYPES_SUCCESS,
      PublicContent.getPhoneTypesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_PHONE_TYPES_FAILURE,
      PublicContent.getPhoneTypesFailure
    ),
    //
    takeLatest(
      PublicContentTypes.GET_ETHNICITY_OPTIONS,
      PublicContent.getEthnicityOptions
    ),
    takeLatest(
      PublicContentTypes.GET_ETHNICITY_OPTIONS_SUCCESS,
      PublicContent.getEthnicityOptionsSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_ETHNICITY_OPTIONS_FAILURE,
      PublicContent.getEthnicityOptionsFailure
    ),
    //
    takeLatest(
      PublicContentTypes.SAVE_CONTACT_FORM,
      PublicContent.saveContactForm
    ),
    takeLatest(
      PublicContentTypes.SAVE_CONTACT_FORM_SUCCESS,
      PublicContent.saveContactFormSuccess
    ),
    takeLatest(
      PublicContentTypes.SAVE_CONTACT_FORM_FAILURE,
      PublicContent.saveContactFormFailure
    ),
    //
    takeLatest(
      PublicContentTypes.GET_LOYALTY_ACHIEVEMENT_BADGES,
      PublicContent.getLoyaltyAchievementBadges
    ),
    takeLatest(
      PublicContentTypes.GET_LOYALTY_ACHIEVEMENT_BADGES_SUCCESS,
      PublicContent.getLoyaltyAchievementBadgesSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_LOYALTY_ACHIEVEMENT_BADGES_FAILURE,
      PublicContent.getLoyaltyAchievementBadgesFailure
    ),
    //
    takeLatest(
      PublicContentTypes.GET_REDEEM_PAUSED,
      PublicContent.getRedeemPaused
    ),
    takeLatest(
      PublicContentTypes.GET_REDEEM_PAUSED_SUCCESS,
      PublicContent.getRedeemPausedSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_REDEEM_PAUSED_FAILURE,
      PublicContent.getRedeemPausedFailure
    ),

    takeLatest(
      PublicContentTypes.GET_VENDOR_REDEEM_PAUSED,
      PublicContent.getVendorRedeemPaused
    ),
    takeLatest(
      PublicContentTypes.GET_VENDOR_REDEEM_PAUSED_SUCCESS,
      PublicContent.getVendorRedeemPausedSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_VENDOR_REDEEM_PAUSED_FAILURE,
      PublicContent.getVendorRedeemPausedFailure
    ),

    takeEvery(
      PublicContentTypes.DRUPAL_MENU_FETCH,
      PublicContent.drupalMenuFetch
    ),
    takeLatest(
      PublicContentTypes.DRUPAL_MENU_FETCH_SUCCESS,
      PublicContent.drupalMenuFetchSuccess
    ),
    takeLatest(
      PublicContentTypes.DRUPAL_MENU_FETCH_FAILURE,
      PublicContent.drupalMenuFetchFailure
    ),

    takeLatest(
      PublicContentTypes.GET_DRUPAL_HOMEPAGE,
      PublicContent.getDrupalHomepage
    ),
    takeLatest(
      PublicContentTypes.GET_DRUPAL_HOMEPAGE_SUCCESS,
      PublicContent.getDrupalHomepageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_DRUPAL_HOMEPAGE_FAILURE,
      PublicContent.getDrupalHomepageFailure
    ),

    takeLatest(
      PublicContentTypes.GET_PATIENT_TESTIMONIALS,
      PublicContent.getPatientTestimonials
    ),
    takeLatest(
      PublicContentTypes.GET_PATIENT_TESTIMONIALS_SUCCESS,
      PublicContent.getPatientTestimonialsSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_PATIENT_TESTIMONIALS_FAILURE,
      PublicContent.getPatientTestimonialsFailure
    ),

    takeLatest(
      PublicContentTypes.GET_DRUPAL_NAVIGATION,
      PublicContent.getDrupalNavigation
    ),
    takeLatest(
      PublicContentTypes.GET_DRUPAL_NAVIGATION_SUCCESS,
      PublicContent.getDrupalNavigationSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_DRUPAL_NAVIGATION_FAILURE,
      PublicContent.getDrupalNavigationFailure
    ),

    takeEvery(PublicContentTypes.GET_FORMS_PAGE, PublicContent.getFormsPage),
    takeLatest(
      PublicContentTypes.GET_FORMS_PAGE_SUCCESS,
      PublicContent.getFormsPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_FORMS_PAGE_FAILURE,
      PublicContent.getFormsPageFailure
    ),

    takeLatest(PublicContentTypes.GET_CUSTOM_PAGE, PublicContent.getCustomPage),

    takeLatest(
      PublicContentTypes.GET_CUSTOM_PAGE_SUCCESS,
      PublicContent.getCustomPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_CUSTOM_PAGE_FAILURE,
      PublicContent.getCustomPageFailure
    ),

    takeLatest(
      PublicContentTypes.GET_PROMOTIONAL_BANNER,
      PublicContent.getPromotionalBanner
    ),

    takeLatest(
      PublicContentTypes.GET_PROMOTIONAL_BANNER_SUCCESS,
      PublicContent.getPromotionalBannerSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_PROMOTIONAL_BANNER_FAILURE,
      PublicContent.getPromotionalBannerFailure
    ),

    takeLatest(
      PublicContentTypes.GET_LOCATIONS_PAGE,
      PublicContent.getLocationsPage
    ),

    takeLatest(
      PublicContentTypes.GET_LOCATIONS_PAGE_SUCCESS,
      PublicContent.getLocationsPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_LOCATIONS_PAGE_FAILURE,
      PublicContent.getLocationsPageFailure
    ),

    takeLatest(
      PublicContentTypes.GET_CENTER_DETAILS_PAGE,
      PublicContent.getCenterDetailsPage
    ),
    takeLatest(
      PublicContentTypes.GET_CENTER_DETAILS_PAGE_SUCCESS,
      PublicContent.getCenterDetailsPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_CENTER_DETAILS_PAGE_FAILURE,
      PublicContent.getCenterDetailsPageFailure
    ),
    takeLatest(
      PublicContentTypes.GET_POST_LOGIN_PAGE,
      PublicContent.getPostLoginPage
    ),
    takeLatest(
      PublicContentTypes.GET_POST_LOGIN_PAGE_SUCCESS,
      PublicContent.getPostLoginPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_POST_LOGIN_PAGE_FAILURE,
      PublicContent.getPostLoginPageFailure
    ),

    /* APPOINTMENTS */
    takeLatest(
      AppointmentsTypes.SCHEDULE_APPOINTMENT,
      Appointments.scheduleAppointment
    ),
    takeLatest(
      AppointmentsTypes.SCHEDULE_APPOINTMENT_SUCCESS,
      Appointments.scheduleAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.SCHEDULE_APPOINTMENT_FAILURE,
      Appointments.scheduleAppointmentFailure
    ),
    //
    takeLatest(
      AppointmentsTypes.SCHEDULE_QUICK_APPOINTMENT,
      Appointments.scheduleQuickAppointment
    ),
    takeLatest(
      AppointmentsTypes.SCHEDULE_QUICK_APPOINTMENT_SUCCESS,
      Appointments.scheduleQuickAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.SCHEDULE_QUICK_APPOINTMENT_FAILURE,
      Appointments.scheduleQuickAppointmentFailure
    ),
    //
    takeLatest(
      AppointmentsTypes.GET_ALL_APPOINTMENTS,
      Appointments.getAllAppointments
    ),
    takeLatest(
      AppointmentsTypes.GET_ALL_APPOINTMENTS_SUCCESS,
      Appointments.getAllAppointmentsSuccess
    ),
    takeLatest(
      AppointmentsTypes.GET_ALL_APPOINTMENTS_FAILURE,
      Appointments.getAllAppointmentsFailure
    ),
    //
    takeLatest(AppointmentsTypes.GET_APPOINTMENT, Appointments.getAppointment),
    takeLatest(
      AppointmentsTypes.GET_APPOINTMENT_SUCCESS,
      Appointments.getAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.GET_APPOINTMENT_FAILURE,
      Appointments.getAppointmentFailure
    ),
    //
    takeLatest(
      AppointmentsTypes.RESCHEDULE_APPOINTMENT,
      Appointments.rescheduleAppointment
    ),
    takeLatest(
      AppointmentsTypes.RESCHEDULE_APPOINTMENT_SUCCESS,
      Appointments.rescheduleAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.RESCHEDULE_APPOINTMENT_FAILURE,
      Appointments.rescheduleAppointmentFailure
    ),
    //
    takeLatest(
      AppointmentsTypes.CANCEL_APPOINTMENT,
      Appointments.cancelAppointment
    ),
    takeLatest(
      AppointmentsTypes.CANCEL_APPOINTMENT_SUCCESS,
      Appointments.cancelAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.CANCEL_APPOINTMENT_FAILURE,
      Appointments.cancelAppointmentFailure
    ),

    /* NEW - APPOINTMENTS */

    takeLatest(
      AppointmentsTypes.GET_AVAILABLE_SLOTS,
      Appointments.getAvailableSlots
    ),
    takeLatest(
      AppointmentsTypes.GET_AVAILABLE_SLOTS_SUCCESS,
      Appointments.getAvailableSlotsSuccess
    ),
    takeLatest(
      AppointmentsTypes.GET_AVAILABLE_SLOTS_FAILURE,
      Appointments.getAvailableSlotsFailure
    ),

    takeLatest(
      AppointmentsTypes.CREATE_NEW_APPOINTMENT,
      Appointments.createNewAppointment
    ),
    takeLatest(
      AppointmentsTypes.CREATE_NEW_APPOINTMENT_SUCCESS,
      Appointments.createNewAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.CREATE_NEW_APPOINTMENT_FAILURE,
      Appointments.createNewAppointmentFailure
    ),

    takeLatest(
      AppointmentsTypes.VALIDATE_APPOINTMENT,
      Appointments.validateAppointment
    ),
    takeLatest(
      AppointmentsTypes.VALIDATE_APPOINTMENT_SUCCESS,
      Appointments.validateAppointmentSuccess
    ),
    takeLatest(
      AppointmentsTypes.VALIDATE_APPOINTMENT_FAILURE,
      Appointments.validateAppointmentFailure
    ),

    takeLatest(
      AppointmentsTypes.GET_UPCOMING_APPOINTMENTS,
      Appointments.getUpcomingAppointments
    ),
    takeLatest(
      AppointmentsTypes.GET_UPCOMING_APPOINTMENTS_SUCCESS,
      Appointments.getUpcomingAppointmentsSuccess
    ),
    takeLatest(
      AppointmentsTypes.GET_UPCOMING_APPOINTMENTS_FAILURE,
      Appointments.getUpcomingAppointmentsFailure
    ),

    takeLatest(
      AppointmentsTypes.NEW_DONOR_BONUS_ELIGIBILITY,
      Appointments.newDonorBonusEligibility
    ),
    takeLatest(
      AppointmentsTypes.NEW_DONOR_BONUS_ELIGIBILITY_SUCCESS,
      Appointments.newDonorBonusEligibilitySuccess
    ),
    takeLatest(
      AppointmentsTypes.NEW_DONOR_BONUS_ELIGIBILITY_FAILURE,
      Appointments.newDonorBonusEligibilityFailure
    ),

    takeLatest(
      AppointmentsTypes.UPDATE_GIFT_CARD_PREFERENCE,
      Appointments.updateGiftCardPreference
    ),
    takeLatest(
      AppointmentsTypes.UPDATE_GIFT_CARD_PREFERENCE_SUCCESS,
      Appointments.updateGiftCardPreferenceSuccess
    ),
    takeLatest(
      AppointmentsTypes.UPDATE_GIFT_CARD_PREFERENCE_FAILURE,
      Appointments.updateGiftCardPreferenceFailure
    ),

    // /* CENTERS */
    takeLatest(CentersTypes.GET_ALL_CENTERS, Centers.getAllCenters),
    takeLatest(
      CentersTypes.GET_ALL_CENTERS_SUCCESS,
      Centers.getAllCentersSuccess
    ),
    takeLatest(
      CentersTypes.GET_ALL_CENTERS_FAILURE,
      Centers.getAllCentersFailure
    ),
    // Secondary Center
    takeLatest(
      CentersTypes.GET_APPOINTMENT_CENTER,
      Centers.getAppointmentCenter
    ),
    takeLatest(
      CentersTypes.GET_APPOINTMENT_CENTER_SUCCESS,
      Centers.getAppointmentCenterSuccess
    ),
    takeLatest(
      CentersTypes.GET_APPOINTMENT_CENTER_FAILURE,
      Centers.getAppointmentCenterFailure
    ),
    //
    takeLatest(CentersTypes.GET_DONOR_CENTERS_ALL, Centers.getDonorCentersAll),
    takeLatest(
      CentersTypes.GET_DONOR_CENTERS_ALL_SUCCESS,
      Centers.getDonorCentersAllSuccess
    ),
    takeLatest(
      CentersTypes.GET_DONOR_CENTERS_ALL_FAILURE,
      Centers.getDonorCentersAllFailure
    ),
    //
    takeLatest(CentersTypes.GET_STATE_CENTERS, Centers.getStateCenters),
    takeLatest(
      CentersTypes.GET_STATE_CENTERS_SUCCESS,
      Centers.getStateCentersSuccess
    ),
    takeLatest(
      CentersTypes.GET_STATE_CENTERS_FAILURE,
      Centers.getStateCentersFailure
    ),
    //
    takeLatest(
      CentersTypes.GET_ZIPCODE_SEARCH_CENTERS,
      Centers.getZipcodeSearchCenters
    ),
    takeLatest(
      CentersTypes.GET_ZIPCODE_SEARCH_CENTERS_SUCCESS,
      Centers.getZipcodeSearchCentersSuccess
    ),
    takeLatest(
      CentersTypes.GET_ZIPCODE_SEARCH_CENTERS_FAILURE,
      Centers.getZipcodeSearchCentersFailure
    ),
    //
    takeLatest(CentersTypes.GET_DONOR_CENTER_INFO, Centers.getDonorCenterInfo),
    takeLatest(
      CentersTypes.GET_DONOR_CENTER_INFO_SUCCESS,
      Centers.getDonorCenterInfoSuccess
    ),
    takeLatest(
      CentersTypes.GET_DONOR_CENTER_INFO_FAILURE,
      Centers.getDonorCenterInfoFailure
    ),
    takeLatest(
      CentersTypes.GET_FAVORITE_CENTER_INFO,
      Centers.getFavoriteCenterInfo
    ),
    takeLatest(
      CentersTypes.GET_FAVORITE_CENTER_INFO_SUCCESS,
      Centers.getFavoriteCenterInfoSuccess
    ),
    takeLatest(
      CentersTypes.GET_FAVORITE_CENTER_INFO_FAILURE,
      Centers.getFavoriteCenterInfoFailure
    ),
    takeLatest(
      CentersTypes.UPDATE_FAVORITE_CENTER,
      Centers.updateFavoriteCenter
    ),
    takeLatest(
      CentersTypes.UPDATE_FAVORITE_CENTER_SUCCESS,
      Centers.updateFavoriteCenterSuccess
    ),
    takeLatest(
      CentersTypes.UPDATE_FAVORITE_CENTER_FAILURE,
      Centers.updateFavoriteCenterFailure
    ),
    //
    takeLatest(
      CentersTypes.GET_ALTERNATE_DONOR_CENTERS_INFO,
      Centers.getAlternateDonorCentersInfo
    ),
    takeLatest(
      CentersTypes.GET_ALTERNATE_DONOR_CENTERS_INFO_SUCCESS,
      Centers.getAlternateDonorCentersInfoSuccess
    ),
    takeLatest(
      CentersTypes.GET_ALTERNATE_DONOR_CENTERS_INFO_FAILURE,
      Centers.getAlternateDonorCentersInfoFailure
    ),
    //
    takeLatest(CentersTypes.GET_CENTER_INFO, Centers.getCenterInfo),
    takeLatest(
      CentersTypes.GET_CENTER_INFO_SUCCESS,
      Centers.getCenterInfoSuccess
    ),
    takeLatest(
      CentersTypes.GET_CENTER_INFO_FAILURE,
      Centers.getCenterInfoFailure
    ),
    //
    takeLatest(CentersTypes.GET_APPOINTMENT_SLOT, Centers.getAppointmentSlot),
    takeLatest(
      CentersTypes.GET_APPOINTMENT_SLOT_SUCCESS,
      Centers.getAppointmentSlotSuccess
    ),
    takeLatest(
      CentersTypes.GET_APPOINTMENT_SLOT_FAILURE,
      Centers.getAppointmentSlotFailure
    ),
    //
    takeLatest(CentersTypes.ADD_APPOINTMENT_SLOT, Centers.addAppointmentSlot),
    takeLatest(
      CentersTypes.ADD_APPOINTMENT_SLOT_SUCCESS,
      Centers.addAppointmentSlotSuccess
    ),
    takeLatest(
      CentersTypes.ADD_APPOINTMENT_SLOT_FAILURE,
      Centers.addAppointmentSlotFailure
    ),
    //
    takeLatest(
      CentersTypes.GET_SLOTS_FOR_APPOINTMENT_TYPE,
      Centers.getSlotsForAppointmentType
    ),
    takeLatest(
      CentersTypes.GET_SLOTS_FOR_APPOINTMENT_TYPE_SUCCESS,
      Centers.getSlotsForAppointmentTypeSuccess
    ),
    takeLatest(
      CentersTypes.GET_SLOTS_FOR_APPOINTMENT_TYPE_FAILURE,
      Centers.getSlotsForAppointmentTypeFailure
    ),
    //
    takeLatest(CentersTypes.GET_SLOTS_FOR_DONOR, Centers.getSlotsForDonor),
    takeLatest(
      CentersTypes.GET_SLOTS_FOR_DONOR_SUCCESS,
      Centers.getSlotsForDonorSuccess
    ),
    takeLatest(
      CentersTypes.GET_SLOTS_FOR_DONOR_FAILURE,
      Centers.getSlotsForDonorFailure
    ),

    // NEW

    takeLatest(CentersTypes.REGISTER_GET_CENTERS, Centers.registerGetCenters),
    takeLatest(
      CentersTypes.REGISTER_GET_CENTERS_SUCCESS,
      Centers.registerGetCentersSuccess
    ),
    takeLatest(
      CentersTypes.REGISTER_GET_CENTERS_FAILURE,
      Centers.registerGetCentersFailure
    ),

    takeLatest(
      CentersTypes.GET_APPOINTMENT_REPORT,
      Centers.getAppointmentReport
    ),
    takeLatest(
      CentersTypes.GET_APPOINTMENT_REPORT_SUCCESS,
      Centers.getAppointmentReportSuccess
    ),
    takeLatest(
      CentersTypes.GET_APPOINTMENT_REPORT_FAILURE,
      Centers.getAppointmentReportFailure
    ),

    takeLatest(CentersTypes.DOWNLOAD_REPORT, Centers.downloadReport),
    takeLatest(
      CentersTypes.DOWNLOAD_REPORT_SUCCESS,
      Centers.downloadReportSuccess
    ),
    takeLatest(
      CentersTypes.DOWNLOAD_REPORT_FAILURE,
      Centers.downloadReportFailure
    ),

    takeLatest(CentersTypes.GET_CENTER_CALENDAR, Centers.getCenterCalendar),
    takeLatest(
      CentersTypes.GET_CENTER_CALENDAR_SUCCESS,
      Centers.getCenterCalendarSuccess
    ),
    takeLatest(
      CentersTypes.GET_CENTER_CALENDAR_FAILURE,
      Centers.getCenterCalendarFailure
    ),

    takeLatest(
      CentersTypes.GET_CENTER_SLOT_CONFIG,
      Centers.getCenterSlotConfig
    ),
    takeLatest(
      CentersTypes.GET_CENTER_SLOT_CONFIG_SUCCESS,
      Centers.getCenterSlotConfigSuccess
    ),
    takeLatest(
      CentersTypes.GET_CENTER_SLOT_CONFIG_FAILURE,
      Centers.getCenterSlotConfigFailure
    ),

    takeLatest(
      CentersTypes.SAVE_CENTER_SLOT_CONFIG,
      Centers.saveCenterSlotConfig
    ),
    takeLatest(
      CentersTypes.SAVE_CENTER_SLOT_CONFIG_SUCCESS,
      Centers.saveCenterSlotConfigSuccess
    ),
    takeLatest(
      CentersTypes.SAVE_CENTER_SLOT_CONFIG_FAILURE,
      Centers.saveCenterSlotConfigFailure
    ),

    takeLatest(
      CentersTypes.CREATE_APPLICATION_USER,
      Centers.createApplicationUser
    ),
    takeLatest(
      CentersTypes.CREATE_APPLICATION_USER_SUCCESS,
      Centers.createApplicationUserSuccess
    ),
    takeLatest(
      CentersTypes.CREATE_APPLICATION_USER_FAILURE,
      Centers.createApplicationUserFailure
    ),

    takeLatest(
      CentersTypes.SEARCH_APPLICATION_USER,
      Centers.searchApplicationUser
    ),
    takeLatest(
      CentersTypes.SEARCH_APPLICATION_USER_SUCCESS,
      Centers.searchApplicationUserSuccess
    ),
    takeLatest(
      CentersTypes.SEARCH_APPLICATION_USER_FAILURE,
      Centers.searchApplicationUserFailure
    ),

    takeLatest(
      CentersTypes.GET_APPLICATION_USER_DETAILS,
      Centers.getApplicationUserDetails
    ),
    takeLatest(
      CentersTypes.GET_APPLICATION_USER_DETAILS_SUCCESS,
      Centers.getApplicationUserDetailsSuccess
    ),
    takeLatest(
      CentersTypes.GET_APPLICATION_USER_DETAILS_FAILURE,
      Centers.getApplicationUserDetailsFailure
    ),

    takeLatest(CentersTypes.EDIT_APPLICATION_USER, Centers.editApplicationUser),
    takeLatest(
      CentersTypes.EDIT_APPLICATION_USER_SUCCESS,
      Centers.editApplicationUserSuccess
    ),
    takeLatest(
      CentersTypes.EDIT_APPLICATION_USER_FAILURE,
      Centers.editApplicationUserFailure
    ),

    takeLatest(
      CentersTypes.REMOVE_USER_CENTER_ACCESS,
      Centers.removeUserCenterAccess
    ),
    takeLatest(
      CentersTypes.REMOVE_USER_CENTER_ACCESS_SUCCESS,
      Centers.removeUserCenterAccessSuccess
    ),
    takeLatest(
      CentersTypes.REMOVE_USER_CENTER_ACCESS_FAILURE,
      Centers.removeUserCenterAccessFailure
    ),

    takeLatest(
      CentersTypes.REMOVE_USER_PORTAL_ACCESS,
      Centers.removeUserPortalAccess
    ),
    takeLatest(
      CentersTypes.REMOVE_USER_PORTAL_ACCESS_SUCCESS,
      Centers.removeUserPortalAccessSuccess
    ),
    takeLatest(
      CentersTypes.REMOVE_USER_PORTAL_ACCESS_FAILURE,
      Centers.removeUserPortalAccessFailure
    ),

    takeLatest(
      CentersTypes.UPDATE_USER_DEFAULT_CENTER,
      Centers.updateUserDefaultCenter
    ),
    takeLatest(
      CentersTypes.UPDATE_USER_DEFAULT_CENTER_SUCCESS,
      Centers.updateUserDefaultCenterSuccess
    ),
    takeLatest(
      CentersTypes.UPDATE_USER_DEFAULT_CENTER_FAILURE,
      Centers.updateUserDefaultCenterFailure
    ),

    takeLatest(
      CentersTypes.ADD_USER_CENTER_ACCESS,
      Centers.addUserCenterAccess
    ),
    takeLatest(
      CentersTypes.ADD_USER_CENTER_ACCESS_SUCCESS,
      Centers.addUserCenterAccessSuccess
    ),
    takeLatest(
      CentersTypes.ADD_USER_CENTER_ACCESS_FAILURE,
      Centers.addUserCenterAccessFailure
    ),

    /* DONORS */
    takeLatest(DonorTypes.GET_ALL_DONORS, Donor.getAllDonors),
    takeLatest(DonorTypes.GET_ALL_DONORS_SUCCESS, Donor.getAllDonorsSuccess),
    takeLatest(DonorTypes.GET_ALL_DONORS_FAILURE, Donor.getAllDonorsFailure),
    //
    takeLatest(DonorTypes.GET_DONORS, Donor.getDonors),
    takeLatest(DonorTypes.GET_DONORS_SUCCESS, Donor.getDonorsSuccess),
    takeLatest(DonorTypes.GET_DONORS_FAILURE, Donor.getDonorsFailure),
    //
    takeLatest(DonorTypes.GET_DONOR_BY_SFID, Donor.getDonorBySfid),
    takeLatest(
      DonorTypes.GET_DONOR_BY_SFID_SUCCESS,
      Donor.getDonorBySfidSuccess
    ),
    takeLatest(
      DonorTypes.GET_DONOR_BY_SFID_FAILURE,
      Donor.getDonorBySfidFailure
    ),
    //
    takeLatest(DonorTypes.SEARCH_FOR_DONOR, Donor.searchForDonor),
    takeLatest(
      DonorTypes.SEARCH_FOR_DONOR_SUCCESS,
      Donor.searchForDonorSuccess
    ),
    takeLatest(
      DonorTypes.SEARCH_FOR_DONOR_FAILURE,
      Donor.searchForDonorFailure
    ),
    //
    takeLatest(DonorTypes.SEARCH_ACTIVE_DONORS, Donor.searchActiveDonors),
    takeLatest(
      DonorTypes.SEARCH_ACTIVE_DONORS_SUCCESS,
      Donor.searchActiveDonorsSuccess
    ),
    takeLatest(
      DonorTypes.SEARCH_ACTIVE_DONORS_FAILURE,
      Donor.searchActiveDonorsFailure
    ),
    //
    takeLatest(DonorTypes.REGISTER_DONOR, Donor.registerDonor),
    takeLatest(DonorTypes.REGISTER_DONOR_SUCCESS, Donor.registerDonorSuccess),
    takeLatest(DonorTypes.REGISTER_DONOR_FAILURE, Donor.registerDonorFailure),
    //
    takeLatest(
      DonorTypes.REGISTER_GET_DONOR_PROFILE,
      Donor.registerGetDonorProfile
    ),
    takeLatest(
      DonorTypes.REGISTER_GET_DONOR_PROFILE_SUCCESS,
      Donor.registerGetDonorProfileSuccess
    ),
    takeLatest(
      DonorTypes.REGISTER_GET_DONOR_PROFILE_FAILURE,
      Donor.registerGetDonorProfileFailure
    ),
    //
    takeLatest(DonorTypes.UPDATE_DONOR, Donor.updateDonor),
    takeLatest(DonorTypes.UPDATE_DONOR_SUCCESS, Donor.updateDonorSuccess),
    takeLatest(DonorTypes.UPDATE_DONOR_FAILURE, Donor.updateDonorFailure),
    //
    takeLatest(DonorTypes.INQUIRY_DONOR, Donor.inquiryDonor),
    takeLatest(DonorTypes.INQUIRY_DONOR_SUCCESS, Donor.inquiryDonorSuccess),
    takeLatest(DonorTypes.INQUIRY_DONOR_FAILURE, Donor.inquiryDonorFailure),
    //
    takeLatest(DonorTypes.GET_DONORS_PREFERENCES, Donor.getDonorsPreferences),
    takeLatest(
      DonorTypes.GET_DONORS_PREFERENCES_SUCCESS,
      Donor.getDonorsPreferencesSuccess
    ),
    takeLatest(
      DonorTypes.GET_DONORS_PREFERENCES_FAILURE,
      Donor.getDonorsPreferencesFailure
    ),
    //
    takeLatest(
      DonorTypes.UPDATE_DONORS_PREFERENCES,
      Donor.updateDonorsPreferences
    ),
    takeLatest(
      DonorTypes.UPDATE_DONORS_PREFERENCES_SUCCESS,
      Donor.updateDonorsPreferencesSuccess
    ),
    takeLatest(
      DonorTypes.UPDATE_DONORS_PREFERENCES_FAILURE,
      Donor.updateDonorsPreferencesFailure
    ),
    takeLatest(
      DonorTypes.GET_DONOR_LIFETIME_IMPACT,
      Donor.getDonorLifetimeImpact
    ),
    takeLatest(
      DonorTypes.GET_DONOR_LIFETIME_IMPACT_SUCCESS,
      Donor.getDonorLifetimeImpactSuccess
    ),
    takeLatest(
      DonorTypes.GET_DONOR_LIFETIME_IMPACT_FAILURE,
      Donor.getDonorLifetimeImpactFailure
    ),

    takeLatest(DonorTypes.GET_DONOR_APC_STATUS, Donor.getDonorApcStatus),
    takeLatest(
      DonorTypes.GET_DONOR_APC_STATUS_SUCCESS,
      Donor.getDonorApcStatusSuccess
    ),
    takeLatest(
      DonorTypes.GET_DONOR_APC_STATUS_FAILURE,
      Donor.getDonorApcStatusFailure
    ),

    takeLatest(
      DonorTypes.GET_DONOR_REFER_EARNED_AMOUNT,
      Donor.getDonorReferEarnedAmount
    ),
    takeLatest(
      DonorTypes.GET_DONOR_REFER_EARNED_AMOUNT_SUCCESS,
      Donor.getDonorReferEarnedAmountSuccess
    ),
    takeLatest(
      DonorTypes.GET_DONOR_REFER_EARNED_AMOUNT_FAILURE,
      Donor.getDonorReferEarnedAmountFailure
    ),

    /*Loyalty Details */
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_DETAILS,
      LoyalDonor.getLoyaltyDetails
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_DETAILS_SUCCESS,
      LoyalDonor.getLoyaltyDetailsSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_DETAILS_FAILURE,
      LoyalDonor.getLoyaltyDetailsFailure
    ),
    

    /*Loyalty contants */
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_CONSTANT,
      LoyalDonor.getLoyaltyConstant
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_CONSTANT_SUCCESS,
      LoyalDonor.getLoyaltyConstantSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_CONSTANT_FAILURE,
      LoyalDonor.getLoyaltyConstantFailure
    ),

    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_ACTIVITY,
      LoyalDonor.getLoyaltyActivity
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_ACTIVITY_SUCCESS,
      LoyalDonor.getLoyaltyActivitySuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_ACTIVITY_FAILURE,
      LoyalDonor.getLoyaltyActivityFailure
    ),

    /*Loyalty redeem Rewards */
    takeLatest(LoyaltyDetailsTypes.REDEEM_REWARDS, LoyalDonor.redeemRewards),
    takeLatest(
      LoyaltyDetailsTypes.REDEEM_REWARDS_SUCCESS,
      LoyalDonor.redeemRewardsSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.REDEEM_REWARDS_FAILURE,
      LoyalDonor.redeemRewardsFailure
    ),

    takeLatest(
      LoyaltyDetailsTypes.REDEEM_REWARDS_STATUS_CHECK,
      LoyalDonor.redeemRewardsStatusCheck
    ),
    takeLatest(
      LoyaltyDetailsTypes.REDEEM_REWARDS_STATUS_CHECK_SUCCESS,
      LoyalDonor.redeemRewardsStatusCheckSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.REDEEM_REWARDS_STATUS_CHECK_FAILURE,
      LoyalDonor.redeemRewardsStatusCheckFailure
    ),

    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_PROMOTIONS,
      LoyalDonor.getLoyaltyPromotions
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_PROMOTIONS_SUCCESS,
      LoyalDonor.getLoyaltyPromotionsSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_PROMOTIONS_FAILURE,
      LoyalDonor.getLoyaltyPromotionsFailure
    ),

    takeLatest(
      LoyaltyDetailsTypes.ACTIVATE_LOYALTY_PROMOTIONS,
      LoyalDonor.activateLoyaltyPromotions
    ),
    takeLatest(
      LoyaltyDetailsTypes.ACTIVATE_LOYALTY_PROMOTIONS_SUCCESS,
      LoyalDonor.activateLoyaltyPromotionsSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.ACTIVATE_LOYALTY_PROMOTIONS_FAILURE,
      LoyalDonor.activateLoyaltyPromotionsFailure
    ),

    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_GAME_DATA,
      LoyalDonor.getLoyaltyGameData
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_GAME_DATA_SUCCESS,
      LoyalDonor.getLoyaltyGameDataSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.GET_LOYALTY_GAME_DATA_FAILURE,
      LoyalDonor.getLoyaltyGameDataFailure
    ),

    takeLatest(
      LoyaltyDetailsTypes.UPDATE_LOYALTY_GAME_DATA,
      LoyalDonor.updateLoyaltyGameData
    ),
    takeLatest(
      LoyaltyDetailsTypes.UPDATE_LOYALTY_GAME_DATA_SUCCESS,
      LoyalDonor.updateLoyaltyGameDataSuccess
    ),
    takeLatest(
      LoyaltyDetailsTypes.UPDATE_LOYALTY_GAME_DATA_FAILURE,
      LoyalDonor.updateLoyaltyGameDataFailure
    ),

    //
    /* USERS */
    takeLatest(UsersTypes.LOGIN_AUTH, Users.loginAuth),
    takeLatest(UsersTypes.LOGIN_AUTH_SUCCESS, Users.loginAuthSuccess),
    takeLatest(UsersTypes.LOGIN_AUTH_FAILURE, Users.loginAuthFailure),

    takeLatest(UsersTypes.LOGIN_TOKEN_EXCHANGE, Users.loginTokenExchange),
    takeLatest(
      UsersTypes.LOGIN_TOKEN_EXCHANGE_SUCCESS,
      Users.loginTokenExchangeSuccess
    ),
    takeLatest(
      UsersTypes.LOGIN_TOKEN_EXCHANGE_FAILURE,
      Users.loginTokenExchangeFailure
    ),

    takeLatest(UsersTypes.VERIFY_EMAIL, Users.verifyEmail),
    takeLatest(UsersTypes.VERIFY_EMAIL_SUCCESS, Users.verifyEmailSuccess),
    takeLatest(UsersTypes.VERIFY_EMAIL_FAILURE, Users.verifyEmailFailure),

    takeLatest(UsersTypes.CHANGE_DEFAULT_CENTER, Users.changeDefaultCenter),
    takeLatest(
      UsersTypes.CHANGE_DEFAULT_CENTER_SUCCESS,
      Users.changeDefaultCenterSuccess
    ),
    takeLatest(
      UsersTypes.CHANGE_DEFAULT_CENTER_FAILURE,
      Users.changeDefaultCenterFailure
    ),

    takeLatest(UsersTypes.UPDATE_ACCOUNT_SETTING, Users.updateAccountSetting),
    takeLatest(
      UsersTypes.UPDATE_ACCOUNT_SETTING_SUCCESS,
      Users.updateAccountSettingSuccess
    ),
    takeLatest(
      UsersTypes.UPDATE_ACCOUNT_SETTING_FAILURE,
      Users.updateAccountSettingFailure
    ),

    takeLatest(UsersTypes.MERGE_ACCOUNT_SETTING, Users.mergeAccountSetting),
    takeLatest(
      UsersTypes.MERGE_ACCOUNT_SETTING_SUCCESS,
      Users.mergeAccountSettingSuccess
    ),
    takeLatest(
      UsersTypes.MERGE_ACCOUNT_SETTING_FAILURE,
      Users.mergeAccountSettingFailure
    ),

    takeLatest(UsersTypes.RESEND_VERIFICATION, Users.resendVerification),
    takeLatest(
      UsersTypes.RESEND_VERIFICATION_SUCCESS,
      Users.resendVerificationSuccess
    ),
    takeLatest(
      UsersTypes.RESEND_VERIFICATION_FAILURE,
      Users.resendVerificationFailure
    ),

    takeLatest(UsersTypes.LOGIN, Users.login),
    takeLatest(UsersTypes.LOGIN_SUCCESS, Users.loginSuccess),
    takeLatest(UsersTypes.LOGIN_FAILURE, Users.loginFailure),

    takeLatest(UsersTypes.LOGIN_HEROKU, Users.loginHeroku),
    takeLatest(UsersTypes.LOGIN_HEROKU_SUCCESS, Users.loginHerokuSuccess),
    takeLatest(UsersTypes.LOGIN_HEROKU_FAILURE, Users.loginHerokuFailure),

    takeLatest(UsersTypes.LOGIN_WITH_TOKEN, Users.loginWithToken),
    takeLatest(
      UsersTypes.LOGIN_WITH_TOKEN_SUCCESS,
      Users.loginWithTokenSuccess
    ),
    takeLatest(
      UsersTypes.LOGIN_WITH_TOKEN_FAILURE,
      Users.loginWithTokenFailure
    ),
    //
    takeLatest(UsersTypes.LOGIN_WITH_PROXY_PDN, Users.loginWithProxyPdn),
    takeLatest(
      UsersTypes.LOGIN_WITH_PROXY_PDN_SUCCESS,
      Users.loginWithProxyPdnSuccess
    ),
    takeLatest(
      UsersTypes.LOGIN_WITH_PROXY_PDN_FAILURE,
      Users.loginWithProxyPdnFailure
    ),
    takeLatest(UsersTypes.LOGOUT, Users.logout),
    takeLatest(UsersTypes.LOGOUT_SUCCESS, Users.logoutSuccess),
    takeLatest(UsersTypes.LOGOUT_FAILURE, Users.logoutFailure),
    //
    takeLatest(UsersTypes.REGISTER, Users.register),
    takeLatest(UsersTypes.REGISTER_SUCCESS, Users.registerSuccess),
    takeLatest(UsersTypes.REGISTER_FAILURE, Users.registerFailure),
    //
    takeLatest(UsersTypes.GET_SESSION, Users.getSession),
    takeLatest(UsersTypes.GET_SESSION_SUCCESS, Users.getSessionSuccess),
    takeLatest(UsersTypes.GET_SESSION_FAILURE, Users.getSessionFailure),
    //
    takeLatest(UsersTypes.GET_SESSION_USER, Users.getSessionUser),
    takeLatest(
      UsersTypes.GET_SESSION_USER_SUCCESS,
      Users.getSessionUserSuccess
    ),
    takeLatest(
      UsersTypes.GET_SESSION_USER_FAILURE,
      Users.getSessionUserFailure
    ),
    //
    takeLatest(UsersTypes.GET_LOGGED_IN_USER, Users.getLoggedInUser),
    takeLatest(
      UsersTypes.GET_LOGGED_IN_USER_SUCCESS,
      Users.getLoggedInUserSuccess
    ),
    takeLatest(
      UsersTypes.GET_LOGGED_IN_USER_FAILURE,
      Users.getLoggedInUserFailure
    ),
    //
    takeLatest(UsersTypes.RESET_PASSWORD, Users.resetPassword),
    takeLatest(UsersTypes.RESET_PASSWORD_SUCCESS, Users.resetPasswordSuccess),
    takeLatest(UsersTypes.RESET_PASSWORD_FAILURE, Users.resetPasswordFailure),
    //
    takeLatest(UsersTypes.RESET_PASSWORD2, Users.resetPassword2),
    takeLatest(UsersTypes.RESET_PASSWORD2_SUCCESS, Users.resetPassword2Success),
    takeLatest(UsersTypes.RESET_PASSWORD2_FAILURE, Users.resetPassword2Failure),
    //
    takeLatest(UsersTypes.RESET_PASSWORD3, Users.resetPassword3),
    takeLatest(UsersTypes.RESET_PASSWORD3_SUCCESS, Users.resetPassword3Success),
    takeLatest(UsersTypes.RESET_PASSWORD3_FAILURE, Users.resetPassword3Failure),
    //
    takeLatest(UsersTypes.SETUP_NEW_PASSWORD, Users.setupNewPassword),
    takeLatest(
      UsersTypes.SETUP_NEW_PASSWORD_SUCCESS,
      Users.setupNewPasswordSuccess
    ),
    takeLatest(
      UsersTypes.SETUP_NEW_PASSWORD_FAILURE,
      Users.setupNewPasswordFailure
    ),
    //
    takeLatest(UsersTypes.SESSION_REFRESH, Users.sessionRefresh),
    takeLatest(UsersTypes.SESSION_REFRESH_SUCCESS, Users.sessionRefreshSuccess),
    takeLatest(UsersTypes.SESSION_REFRESH_FAILURE, Users.sessionRefreshFailure),

    takeLatest(UsersTypes.CHANGE_PASSWORD, Users.changePassword),
    takeLatest(UsersTypes.CHANGE_PASSWORD_SUCCESS, Users.changePasswordSuccess),
    takeLatest(UsersTypes.CHANGE_PASSWORD_FAILURE, Users.changePasswordFailure),

    takeLatest(UsersTypes.EMAIL_LOGIN, Users.emailLogin),
    takeLatest(UsersTypes.EMAIL_LOGIN_SUCCESS, Users.emailLoginSuccess),
    takeLatest(UsersTypes.EMAIL_LOGIN_FAILURE, Users.emailLoginFailure),

    takeLatest(UsersTypes.SOCIAL_LOGIN, Users.socialLogin),
    takeLatest(UsersTypes.SOCIAL_LOGIN_SUCCESS, Users.socialLoginSuccess),
    takeLatest(UsersTypes.SOCIAL_LOGIN_FAILURE, Users.socialLoginFailure),

    takeLatest(UsersTypes.ENROLL_MFA, Users.enrollMfa),
    takeLatest(UsersTypes.ENROLL_MFA_SUCCESS, Users.enrollMfaSuccess),
    takeLatest(UsersTypes.ENROLL_MFA_FAILURE, Users.enrollMfaFailure),

    takeLatest(UsersTypes.RESEND_ENROLL_MFA_CODE, Users.resendEnrollMfaCode),
    takeLatest(
      UsersTypes.RESEND_ENROLL_MFA_CODE_SUCCESS,
      Users.resendEnrollMfaCodeSuccess
    ),
    takeLatest(
      UsersTypes.RESEND_ENROLL_MFA_CODE_FAILURE,
      Users.resendEnrollMfaCodeFailure
    ),

    takeLatest(UsersTypes.SEND_MFA_CODE, Users.sendMfaCode),
    takeLatest(UsersTypes.SEND_MFA_CODE_SUCCESS, Users.sendMfaCodeSuccess),
    takeLatest(UsersTypes.SEND_MFA_CODE_FAILURE, Users.sendMfaCodeFailure),

    takeLatest(UsersTypes.VERIFY_MFA_CODE, Users.verifyMfaCode),
    takeLatest(UsersTypes.VERIFY_MFA_CODE_SUCCESS, Users.verifyMfaCodeSuccess),
    takeLatest(UsersTypes.VERIFY_MFA_CODE_FAILURE, Users.verifyMfaCodeFailure),

    // AUTH CUSTOM :: THIS IS GOINF TO REPLACE THE CUSTOM FUNCTONS INSIDE THE USERS SAGAS

    takeLatest(AuthCustomTypes.LOGIN_AUTH, AuthCustom.loginAuth),
    takeLatest(AuthCustomTypes.LOGIN_AUTH_SUCCESS, AuthCustom.loginAuthSuccess),
    takeLatest(AuthCustomTypes.LOGIN_AUTH_FAILURE, AuthCustom.loginAuthFailure),
    //
    takeLatest(
      AuthCustomTypes.LOGIN_TOKEN_EXCHANGE,
      AuthCustom.loginTokenExchange
    ),
    takeLatest(
      AuthCustomTypes.LOGIN_TOKEN_EXCHANGE_SUCCESS,
      AuthCustom.loginTokenExchangeSuccess
    ),
    takeLatest(
      AuthCustomTypes.LOGIN_TOKEN_EXCHANGE_FAILURE,
      AuthCustom.loginTokenExchangeFailure
    ),
    //
    takeLatest(AuthCustomTypes.LOGIN, AuthCustom.login),
    takeLatest(AuthCustomTypes.LOGIN_SUCCESS, AuthCustom.loginSuccess),
    takeLatest(AuthCustomTypes.LOGIN_FAILURE, AuthCustom.loginFailure),
    //
    takeLatest(AuthCustomTypes.LOGIN_HEROKU, AuthCustom.loginHeroku),
    takeLatest(
      AuthCustomTypes.LOGIN_HEROKU_SUCCESS,
      AuthCustom.loginHerokuSuccess
    ),
    takeLatest(
      AuthCustomTypes.LOGIN_HEROKU_FAILURE,
      AuthCustom.loginHerokuFailure
    ),
    //
    takeLatest(AuthCustomTypes.LOGOUT, AuthCustom.logout),
    takeLatest(AuthCustomTypes.LOGOUT_SUCCESS, AuthCustom.logoutSuccess),
    takeLatest(AuthCustomTypes.LOGOUT_FAILURE, AuthCustom.logoutFailure),
    //
    takeLatest(AuthCustomTypes.REGISTER, AuthCustom.register),
    takeLatest(AuthCustomTypes.REGISTER_SUCCESS, AuthCustom.registerSuccess),
    takeLatest(AuthCustomTypes.REGISTER_FAILURE, AuthCustom.registerFailure),
    //
    takeLatest(AuthCustomTypes.GET_SESSION, AuthCustom.getSession),
    takeLatest(
      AuthCustomTypes.GET_SESSION_SUCCESS,
      AuthCustom.getSessionSuccess
    ),
    takeLatest(
      AuthCustomTypes.GET_SESSION_FAILURE,
      AuthCustom.getSessionFailure
    ),
    //
    takeLatest(AuthCustomTypes.GET_SESSION_USER, AuthCustom.getSessionUser),
    takeLatest(
      AuthCustomTypes.GET_SESSION_USER_SUCCESS,
      AuthCustom.getSessionUserSuccess
    ),
    takeLatest(
      AuthCustomTypes.GET_SESSION_USER_FAILURE,
      AuthCustom.getSessionUserFailure
    ),
    //
    takeLatest(AuthCustomTypes.CHANGE_PASSWORD, AuthCustom.changePassword),
    takeLatest(
      AuthCustomTypes.CHANGE_PASSWORD_SUCCESS,
      AuthCustom.changePasswordSuccess
    ),
    takeLatest(
      AuthCustomTypes.CHANGE_PASSWORD_FAILURE,
      AuthCustom.changePasswordFailure
    ),
    //
    takeLatest(
      AuthCustomTypes.CHANGE_RECOVERY_QUESTION,
      AuthCustom.changeRecoveryQuestion
    ),
    takeLatest(
      AuthCustomTypes.CHANGE_RECOVERY_QUESTION_SUCCESS,
      AuthCustom.changeRecoveryQuestionSuccess
    ),
    takeLatest(
      AuthCustomTypes.CHANGE_RECOVERY_QUESTION_FAILURE,
      AuthCustom.changeRecoveryQuestionFailure
    ),
    //
    takeLatest(AuthCustomTypes.FORGOT_PASSWORD, AuthCustom.forgotPassword),
    takeLatest(
      AuthCustomTypes.FORGOT_PASSWORD_SUCCESS,
      AuthCustom.forgotPasswordSuccess
    ),
    takeLatest(
      AuthCustomTypes.FORGOT_PASSWORD_FAILURE,
      AuthCustom.forgotPasswordFailure
    ),
    //
    takeLatest(AuthCustomTypes.SESSION_REFRESH, AuthCustom.sessionRefresh),
    takeLatest(
      AuthCustomTypes.SESSION_REFRESH_SUCCESS,
      AuthCustom.sessionRefreshSuccess
    ),
    takeLatest(
      AuthCustomTypes.SESSION_REFRESH_FAILURE,
      AuthCustom.sessionRefreshFailure
    ),

    // WIRECARD

    takeLatest(WirecardTypes.GET_WIRECARD_INFO, Wirecard.getWirecardInfo),
    takeLatest(
      WirecardTypes.GET_WIRECARD_INFO_SUCCESS,
      Wirecard.getWirecardInfoSuccess
    ),
    takeLatest(
      WirecardTypes.GET_WIRECARD_INFO_FAILURE,
      Wirecard.getWirecardInfoFailure
    ),

    takeLatest(PaymentsTypes.GET_PAYMENT_HISTORY, Payments.getPaymentHistory),
    takeLatest(
      PaymentsTypes.GET_PAYMENT_HISTORY_SUCCESS,
      Payments.getPaymentHistorySuccess
    ),
    takeLatest(
      PaymentsTypes.GET_PAYMENT_HISTORY_FAILURE,
      Payments.getPaymentHistoryFailure
    ),

    // PAYMENTS

    takeLatest(
      PaymentsTypes.GET_PAYMENTS_COUPON_PROGRESS,
      Payments.getPaymentsCouponProgress
    ),
    takeLatest(
      PaymentsTypes.GET_PAYMENTS_COUPON_PROGRESS_SUCCESS,
      Payments.getPaymentsCouponProgressSuccess
    ),
    takeLatest(
      PaymentsTypes.GET_PAYMENTS_COUPON_PROGRESS_FAILURE,
      Payments.getPaymentsCouponProgressFailure
    ),

    takeLatest(UsersTypes.VERIFY_OKTA_ACCOUNT, Users.verifyOktaAccount),
    takeLatest(
      UsersTypes.VERIFY_OKTA_ACCOUNT_SUCCESS,
      Users.verifyOktaAccountSuccess
    ),
    takeLatest(
      UsersTypes.VERIFY_OKTA_ACCOUNT_FAILURE,
      Users.verifyOktaAccountFailure
    ),

    takeLatest(
      PaymentsTypes.APPLY_PAYMENT_PROMO_CODE,
      Payments.applyPaymentPromoCode
    ),
    takeLatest(
      PaymentsTypes.APPLY_PAYMENT_PROMO_CODE_SUCCESS,
      Payments.applyPaymentPromoCodeSuccess
    ),
    takeLatest(
      PaymentsTypes.APPLY_PAYMENT_PROMO_CODE_FAILURE,
      Payments.applyPaymentPromoCodeFailure
    ),

    takeLatest(StartupTypes.INITIALIZE_APP, Startup.initializeApp),
    takeLatest(
      StartupTypes.INITIALIZE_APP_SUCCESS,
      Startup.initializeAppSuccess
    ),
    takeLatest(
      StartupTypes.INITIALIZE_APP_FAILURE,
      Startup.initializeAppFailure
    ),

    takeEvery(
      PublicContentTypes.GET_REGISTRATION_PAGE,
      PublicContent.getRegistrationPage
    ),
    takeLatest(
      PublicContentTypes.GET_REGISTRATION_PAGE_SUCCESS,
      PublicContent.getRegistrationPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_REGISTRATION_PAGE_FAILURE,
      PublicContent.getRegistrationPageFailure
    ),
    takeLatest(
      PublicContentTypes.GET_ONBOARDING_SCREEN_DATA,
      PublicContent.getOnboardingScreenData
    ),
    takeLatest(
      PublicContentTypes.GET_ONBOARDING_SCREEN_DATA_SUCCESS,
      PublicContent.getOnboardingScreenDataSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_ONBOARDING_SCREEN_DATA_FAILURE,
      PublicContent.getOnboardingScreenDataFailure
    ),

    takeLatest(
      PublicContentTypes.GET_MOBILE_SCREEN_DATA,
      PublicContent.getMobileScreenData
    ),
    takeLatest(
      PublicContentTypes.GET_MOBILE_SCREEN_DATA_SUCCESS,
      PublicContent.getMobileScreenDataSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_MOBILE_SCREEN_DATA_FAILURE,
      PublicContent.getMobileScreenDataFailure
    ),
    takeEvery(
      PreviewTypes.GET_DRUPAL_PREVIEW_CONTENT,
      Preview.getDrupalPreviewContent
    ),
    takeLatest(
      PreviewTypes.GET_DRUPAL_PREVIEW_CONTENT_SUCCESS,
      Preview.getDrupalPreviewContentSuccess
    ),
    takeLatest(
      PreviewTypes.GET_DRUPAL_PREVIEW_CONTENT_FAILURE,
      Preview.getDrupalPreviewContentFailure
    ),

    takeLatest(PublicContentTypes.GET_BLOGS_PAGE, PublicContent.getBlogsPage),

    takeLatest(
      PublicContentTypes.GET_BLOGS_PAGE_SUCCESS,
      PublicContent.getBlogsPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_BLOGS_PAGE_FAILURE,
      PublicContent.getBlogsPageFailure
    ),

    takeLatest(PublicContentTypes.GET_NEWS_PAGE, PublicContent.getNewsPage),

    takeLatest(
      PublicContentTypes.GET_NEWS_PAGE_SUCCESS,
      PublicContent.getNewsPageSuccess
    ),
    takeLatest(
      PublicContentTypes.GET_NEWS_PAGE_FAILURE,
      PublicContent.getNewsPageFailure
    ),
    takeLatest(UsersTypes.GET_ENROLLED_MFA_LIST, Users.getEnrolledMfaList),
    takeLatest(
      UsersTypes.GET_ENROLLED_MFA_LIST_SUCCESS,
      Users.getEnrolledMfaListSuccess
    ),
    takeLatest(
      UsersTypes.GET_ENROLLED_MFA_LIST_FAILURE,
      Users.getEnrolledMfaListFailure
    ),
    takeLatest(UsersTypes.AUTHENTICATE_MFA_CODE, Users.authenticateMfaCode),
    takeLatest(
      UsersTypes.AUTHENTICATE_MFA_CODE_SUCCESS,
      Users.authenticateMfaCodeSuccess
    ),
    takeLatest(
      UsersTypes.AUTHENTICATE_MFA_CODE_FAILURE,
      Users.authenticateMfaCodeFailure
    ),
  ]);
}
